import { theme } from "../../theme";
import { useContext } from "react";
import styled from "styled-components";
import {
  MissionCard as StyledMissionCard,
  MissionCardHeader,
  MissionCardTaskButton, // Import for the refresh button
} from "./MissionsContent.styled";
import { AuthContext } from "../../providers/AuthProvider";
import BracketedContainer from "../BracketedContainer";

// New styled component for the completion overlay
const CompletionOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${theme.background}99;
  /* background-opacity: 0.5; */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2; // Ensure it's above other content but below modals if any
  color: ${({ color }) => color};
  font-size: 3rem;
  font-family: "NeueMachina"; // Changed to match header
  font-weight: bold;
  text-transform: uppercase;
  border: none;
  box-sizing: border-box;
`;

const MissionCard = ({
  num,
  title,
  children,
  enabled = false,
  isComplete = false,
  onRefreshMission,
  isLoadingRefresh = false,
}) => {
  const { user } = useContext(AuthContext);

  return (
    <BracketedContainer enabled={enabled} fillBackground={true}>
      <StyledMissionCard
        $isComplete={isComplete} // Pass to styled component for border change
        $primaryColor={theme.baseYellow} // Pass primary color to styled component
      >
        <MissionCardHeader $color={enabled ? theme.baseYellow : theme.gray}>
          <div>
            <strong>{num}: Mission:</strong> {title}
          </div>
        </MissionCardHeader>

        {children}
        {!isComplete && onRefreshMission && (
          <div
            style={{
              padding: "0 1.5rem 1.5rem",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <MissionCardTaskButton
              onClick={onRefreshMission}
              disabled={isLoadingRefresh}
              style={{ marginTop: "1rem" }}
            >
              {isLoadingRefresh ? (
                <>
                  {user ? "Refreshing..." : "Logging in..."}{" "}
                  <span className="spinner">⟳</span>
                </>
              ) : user ? (
                "Refresh"
              ) : (
                "Log in to start"
              )}
            </MissionCardTaskButton>
          </div>
        )}
      </StyledMissionCard>
    </BracketedContainer>
  );
};

export default MissionCard;
